import { CIGNA_DIRECTORY_URL } from '@features/landing/content';

export type FaqLink = {
  label: string;
  href: string;
  external?: boolean;
};

export type FaqItem = {
  id: string;
  question: string;
  answer: string;
  links?: FaqLink[];
};

export const FAQ_INTRO = {
  title: 'Is Lolly legit?',
  paragraphs: [
    'Absolutely. Lolly is 100% real, licensed, and powered by trusted carriers like Cigna, Guardian, and Equitable. We’re not a “too-good-to-be-true” deal — just a better way to get coverage that actually fits the way independents live and work.',
    'We may not always be the cheapest option out there, but we’re transparent about what you’re paying for: quality coverage, real networks, no gimmicks, and no open-enrollment nonsense.',
  ],
};

export const FAQ_ITEMS: FaqItem[] = [
  {
    id: 'medical-id-cards',
    question: 'How and when do I receive my medical ID cards?',
    answer:
      "You will receive an electronic copy of your medical ID card by email a few days before your plan's effective date. You will receive a hard copy by mail after that. Additionally, you can also access a digital copy of your ID card right here in your OneHealth Plus member portal.",
  },
  {
    id: 'cigna-providers',
    question: 'How do I look up providers in the Cigna network?',
    answer:
      'You can click here to search for providers who participate in the Cigna PPO network in your area.',
    links: [
      {
        label: 'click here',
        href: CIGNA_DIRECTORY_URL,
        external: true,
      },
    ],
  },
  {
    id: 'call-cigna',
    question:
      'Should we call Cigna directly if I have a question or if a provider needs to file a claim?',
    answer:
      'No. You should not call Cigna for any reason while covered by this plan. Ours is a private plan, called Triad, that leverages the Cigna network of providers and reimbursement rates for care. If you have any questions about your plan or claims, please call our TPA (third party administrator), called Securus, who can help you as needed. You will find all of this information on the front of your medical ID card.',
  },
  {
    id: 'pharmacy-network',
    question: 'How do I look up if my pharmacy is in network?',
    answer:
      'DisclosedRx has a national pharmacy network of over 70,000 pharmacies. In most cases you can continue using the same pharmacy you already use like CVS, Walgreens, Walmart, or a local pharmacy. Check to confirm your Pharmacy is in the network Pharmacy Locator.',
    links: [
      {
        label: 'Pharmacy Locator',
        href: 'https://www.disclosedrx.com',
        external: true,
      },
    ],
  },
  {
    id: 'additional-coverage',
    question:
      'Can I get additional coverage like dental and vision insurance through OneHealth Plus?',
    answer:
      'Yes. OneHealth Plus offers a full suite of benefits similar to those you would find at a Fortune 500 company. Visit Your Plans in your member portal to explore available coverage options.',
    links: [{ label: 'Your Plans', href: '/healthhub/your-plans' }],
  },
];

export const FAQ_IMPORTANT_TERMS = [
  { term: 'OneHealth Plus', description: 'benefits administrator and billing' },
  { term: 'Cigna Choice PPO', description: 'medical plan network' },
  { term: 'Triad', description: 'the name of your medical plan' },
  {
    term: 'Securus',
    description:
      'TPA (third party administrator) that handles claim adjudication and deductible management',
  },
  {
    term: 'DisclosedRx',
    description:
      'pharmacy benefit manager for all prescription drug related items',
  },
  { term: 'Evo', description: 'telehealth services' },
];

export const FAQ_IMPORTANT_CONTACTS = [
  {
    label:
      'For questions regarding claims and deductible management call Securus:',
    value: '877-420-0785',
    href: 'tel:8774200785',
    extra: 'customerservice@securusbenefits.com',
    extraHref: 'mailto:customerservice@securusbenefits.com',
  },
  {
    label:
      'For questions regarding prescriptions, call DisclosedRx Member Services:',
    value: '888-589-3340',
    href: 'tel:8885893340',
    extra: 'care@disclosedrx.com',
    extraHref: 'mailto:care@disclosedrx.com',
  },
  {
    label: 'For questions regarding your Telehealth services, call Evo Health:',
    value: '855-636-3669',
    href: 'tel:8556363669',
  },
  {
    label: 'To search for an in-network provider, use the',
    linkLabel: 'Cigna Provider Lookup',
    linkHref: CIGNA_DIRECTORY_URL,
  },
  {
    label:
      'For all other items like enrollment, billing or general questions, call OneHealth Plus Customer Service:',
    value: '877-881-4584',
    suffix: 'Mon-Fri 8am-8pm/EST',
    href: 'tel:8778814584',
    extra: 'support@onehealthplus.com',
    extraHref: 'mailto:support@onehealthplus.com',
  },
];
